import { Stack, Box, Button, Grid } from '@ace-clublabs/shared-component-library';
import { ConfirmationSummary, PaymentDetails } from './ConfirmationSections';
import { useRef, useEffect, useState } from 'react';

export const ConfirmationDetails = (props: { handleReturnToMSSHomePage: () => void }) => {
  const boxRef = useRef<HTMLElement>(null);
  const [boxHeight, setBoxHeight] = useState('auto');
  const { handleReturnToMSSHomePage } = props;

  const updateBoxHeight = () => {
    if (boxRef.current) {
      const height = boxRef.current.offsetHeight; // Measure the height of the box container for the confirmation summary and payment details card
      setBoxHeight(`${height}px`); // Set the blue box background height to the size of the container
    }
  };

  useEffect(() => {
    updateBoxHeight();

    window.addEventListener('resize', updateBoxHeight);

    return () => {
      window.removeEventListener('resize', updateBoxHeight);
    };
  }, []);

  return (
    <Stack sx={{ marginTop: '1rem' }}>
      <Box
        className="confirmation-details-container"
        sx={{
          position: 'absolute',
          left: 0,
          right: 0,
          backgroundColor: '#EFF7FE',
          zIndex: -1,
          width: '100vw',
          height: boxHeight,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      />
      <Box ref={boxRef}>
        <Grid
          container
          columnSpacing={'1rem'}
          rowSpacing={'1rem'}
          columns={12}
          sx={{ marginTop: '1.5rem', marginBottom: '1.5rem', height: 'fit-content' }}
        >
          <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
            <ConfirmationSummary />
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
            <PaymentDetails />
          </Grid>
        </Grid>
      </Box>
      <Button
        className="go-to-membership-button"
        sx={{ position: 'relative', margin: '1.5rem 0rem' }}
        label="Go to my membership"
        onClick={handleReturnToMSSHomePage}
      />
    </Stack>
  );
};
